import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CONSENT_KEY = "ss_cookie_consent_v1";

type ConsentValue = "essential" | "all";

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) setShow(true);
  }, []);

  const accept = (value: ConsentValue) => {
    localStorage.setItem(CONSENT_KEY, value);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-consent"
      className="cookie-consent-pos fixed left-4 right-4 md:right-auto md:left-6 md:bottom-6 md:max-w-md z-50 bg-[var(--ink)] text-white p-5 shadow-2xl rounded-sm"
    >
      <div className="text-xs tracking-[0.18em] uppercase text-white/60 mb-2">Cookies</div>
      <p className="text-sm leading-relaxed text-white/90 mb-4">
        We use essential cookies to keep you signed in, plus optional analytics to improve the
        product. No advertising trackers. See our <Link to="/privacy" className="underline underline-offset-2 hover:text-white">privacy policy</Link>.
      </p>
      <div className="flex gap-2">
        <button
          onClick={() => accept("essential")}
          className="flex-1 text-xs px-3 py-2 border border-white/30 hover:bg-white/10 transition-colors"
          data-testid="cookie-essential-btn"
        >
          Essential only
        </button>
        <button
          onClick={() => accept("all")}
          className="flex-1 text-xs px-3 py-2 bg-white text-[var(--ink)] hover:bg-[var(--bg)] transition-colors font-medium"
          data-testid="cookie-accept-all-btn"
        >
          Accept all
        </button>
      </div>
    </div>
  );
}
